import React from "react";
import { Button } from "@shared/ui/button";
import { LucideIcon } from "lucide-react"; 

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  buttonName?: string;
  handleSubmit?: () => void;
  icon?: LucideIcon; 
}

export function PageHeader({
  title,
  subtitle,
  buttonName,
  handleSubmit,
  icon: Icon,
}: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-start gap-3">
        {Icon && <Icon className="w-6 h-6 text-gray mt-1" />}
        <div>
          <p className="page-title">{title}</p>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      </div>

      {buttonName && (
        <Button onClick={handleSubmit}>
          {buttonName}
        </Button>
      )}
    </div>
  );
}
